import { Alignment } from '@lumapps/wrex/types/core';

import { HEADING } from '../constants';
import type { HeadingElement } from '../types';

/** Create heading element */
export function createHeading(
    level: number,
    children: HeadingElement['children'] = [{ text: '' }],
    alignment: Alignment | undefined = undefined,
): HeadingElement {
    return { type: HEADING, level, children, ...(alignment ? { alignment } : undefined) };
}
